import React, { useEffect, useState } from 'react';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import MuiThemeProvider from '@material-ui/core/styles/MuiThemeProvider';
import { createMuiTheme } from '@material-ui/core/styles';
import ClearIcon from '@material-ui/icons/Clear';
import MenuItem from '@material-ui/core/MenuItem';
import style from './style.module.scss';
import i18n from 'common/i18n';
import Message from 'components/Message';
import { useQueryClient } from 'react-query';
import cloneDeep from 'lodash/cloneDeep';
import uniq from 'lodash/uniq';


const customTheme = createMuiTheme({
  typography: {
    useNextVariants: true,
  },
  overrides: {
    MuiDialog: {
      paperWidthSm: {
        width: '488px',
        maxHeight: '80%',
      },
      paper: {
        borderRadius: '20px 20px 20px 20px',
      },
    },
    MuiDialogActions: {
      root: {
        display: 'flex',
        justifyContent: 'center',
      },
    },
    MuiDialogContent: {
      root: {
        padding: 0,
      },
    },
  },
});

const stylePaddingListItem = {
  padding: '5px 0',
};

function FormDialog(props) {
  const [open, setopen] = useState(false);
  const [openalert, setopenalert] = useState(false);
  const [alertmessage, setalertmessage] = useState('');
  const [valueName, setvalueName] = useState(props.namevalue);
  const [valueNameTargets, setValueNameTargets] = useState((props?.nameValues ?? []));
  const [user, setuser] = useState(props.user);

  useEffect(() => {
    setuser(props.user);
    setvalueName(props.namevalue);
    setValueNameTargets((props?.nameValues ? props?.nameValues : []));
  }, [props]);

  const ontextChangePopup = (value) => {
    if (props?.type !== 'multiple' || !props?.type) {
      updateProfile((valueName != value ? value : null), true);
    }
    setvalueName(value);
  };

  const onTextsChangePopup = (value) => {
    const tmpValues = cloneDeep(valueNameTargets);

    const index = valueNameTargets.indexOf(value);
    if (index !== -1) {
      // Remove
      tmpValues.splice(index, 1);
    } else {
      tmpValues.push(value);
    }
    setValueNameTargets(uniq(tmpValues));

    if (props?.type !== 'multiple' || !props?.type) {
      updateProfile(uniq(tmpValues));
    }
  };

  const onChangeListData = (value) => {
    let listData = [...valueName];
    if (listData.length < 1) {
      listData.push(value);
    } else {
      if (listData.indexOf(value) < 0) {
        listData.push(value);
      } else {
        listData.splice(listData.indexOf(value), 1);
      }
    }
    setvalueName(listData);
    if (props?.type !== 'multiple' || !props?.type) {
      updateProfile(listData);
    }
  };

  const renderSelectCustom = (value, key) => {
    if (props?.type === 'multiple') {
      return (
        <div
          key={key}
          id={key}
          style={{
            cursor: 'pointer',
            height: 24,
            color: 'black',
            ...stylePaddingListItem,
          }}
          className={valueName?.includes(value.value) ? `${style.__select_profile} box-selected-item box-text` : `${style.__no__select_profile} box-select-item`}
          value={value.value}
          onClick={() => onChangeListData(value.value)}
        >
          <span className={`${valueName?.includes(value.value) ? '' : 'box-text'}`}>{value.label}</span>
        </div>
      );
    }

    return (
      <MenuItem
        key={key}
        id={value.id + '-' + key}
        className={
          valueName
            ? +value.value === +valueName
            ? `${style.__select_profile} box-selected-item box-text`
            : `${style.__no__select_profile} box-select-item`
            : `${style.__no__select_profile} box-select-item`
        }
        style={{ ...stylePaddingListItem }}
        value={value.value}
        onClick={() => ontextChangePopup(value.value)}
      >
        <span className={`${value.value === valueName ? '' : 'box-text'} vl-name-${valueName}`}>{value.label}</span>
      </MenuItem>
    );
  };

  const updateProfile = async (value = null, isFore = false) => {
    if (value || isFore) {
      props.onchangeData(value);
      setopen(false);
      return;
    }

    /// Array multi
    if (props?.nametext === 'tags' || props?.nametext === 'states') {
      // eslint-disable-next-line no-unused-expressions
      props?.onchangeDatas(valueNameTargets);
      setopen(false);
      return;
    }

    // Single value
    props.onchangeData(valueName);
    setopen(false);
  };

  useEffect(() => {
    if (open) {
      setTimeout(() => {
        handleClose();
      }, 3000);
    }
  }, [open]);

  const handleClose = () => {
    setopenalert(false);
    setalertmessage('');
  };

  return (
    <div>
      <div
        onClick={() => setopen(true)}
        style={{
          minHeight: 30,
          border: '1px solid',
          borderRadius: 10,
          ...props.customStyleContainer,
          ...props?.text && {
            padding: '0 10px',
            display: 'flex',
            justifyContent: 'flex-end',
            alignItems: 'center',
            cursor: 'text',
          },
        }}
        className="border-color wrap-item-filter"
      >
        {props?.text && (<span className="font-3 d-text-search-color"
                               dangerouslySetInnerHTML={{ __html: props?.text }}></span>)}
      </div>
      <MuiThemeProvider theme={customTheme}>
        <Dialog open={open} onClose={() => setopen(false)} aria-labelledby="form-dialog-title">
          <div className={`${style.name__lable} box-header`}>
            <div>{props.namelabel}</div>
          </div>
          <div className={style.__clearicon}>
            <ClearIcon style={{ cursor: 'pointer' }} onClick={() => setopen(false)} color="action" />
          </div>
          <DialogContent>
            {(props.nametext === 'state' || props.nametext === 'area') && (
              <div name={props.nameid}>
                <div>{Array.isArray(valueName) && valueName?.join(',')}</div>
                {props.resource?.map((value, key) => {
                  return (
                    <MenuItem
                      key={key}
                      id={value.id}
                      className={
                        valueName
                          ? value.id === valueName
                          ? `${style.__select_profile} box-selected-item box-text`
                          : `${style.__no__select_profile} box-select-item`
                          : `${style.__no__select_profile} box-select-item`
                      }
                      value={value.id}
                      style={{ ...stylePaddingListItem }}
                      onClick={() => ontextChangePopup(value.id)}
                    >
                      <span className={`${value.id === valueName ? '' : 'box-text'}`}>{value.label}</span>
                    </MenuItem>
                  );
                })}
              </div>
            )}
            {(props.nametext === 'photo' || props.nametext === 'standBy') && (
              <div name={props.nameid}>
                {props.resource?.sort((a, b) => a?.value - b?.value)
                  ?.map((value, key) => {
                  return (
                    <MenuItem
                      key={key}
                      id={value.value}
                      className={
                        valueName
                          ? value.value === valueName
                          ? `${style.__select_profile} box-selected-item box-text`
                          : `${style.__no__select_profile} box-select-item`
                          : `${style.__no__select_profile} box-select-item`
                      }
                      value={value.value}
                      style={{ ...stylePaddingListItem }}
                      onClick={() => ontextChangePopup(value.value)}
                    >
                      <span className={`${value.value === valueName ? '' : 'box-text'}`}>{value.label}</span>
                    </MenuItem>
                  );
                })}
              </div>
            )}
            {(props?.nametext === 'agefrom' || props?.nametext === 'ageto') && (
              <div name={props?.nameid}>
                {props?.resource?.map((value, key) => {
                  return (
                    <MenuItem
                      key={key}
                      id={value}
                      className={
                        valueName
                          ? value === valueName
                          ? `${style.__select_profile} box-selected-item box-text`
                          : `${style.__no__select_profile} box-select-item`
                          : `${style.__no__select_profile} box-select-item`
                      }
                      value={value}
                      style={{ ...stylePaddingListItem }}
                      onClick={() => ontextChangePopup(value)}
                    >
                      <span className={`${value === valueName ? '' : 'box-text'}`}>{value}</span>
                    </MenuItem>
                  );
                })}
              </div>
            )}

            {(props?.nametext === 'states' || props?.nametext === 'tags') && (
              <div name={props?.nameid} id={props?.nametext}>
                {props?.resource?.map((item, key) => {
                  return (
                    <MenuItem
                      key={key}
                      id={item?.id}
                      className={
                        valueNameTargets
                          ? (valueNameTargets ?? []).includes(item?.id)
                          ? `${style.__select_profile} box-selected-item box-text`
                          : `${style.__no__select_profile} box-select-item`
                          : `${style.__no__select_profile} box-select-item`
                      }
                      value={item?.id}
                      style={{ ...stylePaddingListItem }}
                      onClick={() => onTextsChangePopup(item?.id)}
                    >
                      <span className={`${item?.id === valueName ? '' : 'box-text'}`}>{item?.label}</span>
                    </MenuItem>
                  );
                })}
              </div>
            )}

            {!props.nametext && (
              <div name={props.nameid}>
                {props.resource?.sort((a, b) => a?.value - b?.value)?.map((value, key) => renderSelectCustom(value, key))}
              </div>
            )}
          </DialogContent>

          {props?.type && props.type === 'multiple' && (<DialogActions>
            <Button className={`${style.button__save__profile} btn-sub`} onClick={() => updateProfile()} color="primary">
              {i18n.button_save}
            </Button>
          </DialogActions>)}
          <div></div>
        </Dialog>
      </MuiThemeProvider>
      {open ? <Message open={openalert} handleClose={handleClose} alertmessage={alertmessage} /> : null}
    </div>
  );
}

export default FormDialog;
